import { type FilterItemBase, FilterFormBuilder } from "components/filterForms/FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "components/filterForms/types/props";
import { FilterViewTypes } from "enums/filterViewTypes";
import { EmbeddedVideosFiltersEnum } from "../types/models";

export interface FilterFormProps extends FilterFormPropsBase<EmbeddedVideosFiltersEnum> {}

const getFilters = (): FilterItemBase<EmbeddedVideosFiltersEnum>[] => {
  return [
    {
      type: FilterViewTypes.DateRange,
      label: "Date Added",
      propertyName: EmbeddedVideosFiltersEnum.DateCreated,
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Last Modified",
      propertyName: EmbeddedVideosFiltersEnum.DateModified,
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Publisher",
      propertyName: EmbeddedVideosFiltersEnum.Publishers,
      placeholder: "All Publishers",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Packs",
      propertyName: EmbeddedVideosFiltersEnum.Packs,
      placeholder: "All Packs",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Software Applications",
      propertyName: EmbeddedVideosFiltersEnum.SoftwareApplications,
      placeholder: "All Applications",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Labels",
      propertyName: EmbeddedVideosFiltersEnum.Labels,
      placeholder: "All Labels",
    },
    {
      type: FilterViewTypes.Select,
      label: "Visibility",
      propertyName: EmbeddedVideosFiltersEnum.Visibility,
      placeholder: "All Visibility",
    },
  ];
};

export const EmbeddedVideosFilterForm = (props: FilterFormProps) => (
  <FilterFormBuilder
    filterOptions={props.filterOptions}
    filter={props.filter}
    updateFilter={props.updateFilter}
    items={getFilters()}
    onValidationChange={props.onValidationChange}
  />
);
